import React from 'react';
import PropTypes from 'prop-types';
import { Route, useHistory } from 'react-router-dom';

import { store } from '../store';

export default function RouteWrapper ({
  component: Component,
  isPrivate,
  ...rest
}) {

  const history = useHistory();
  
    const { signed } = store.getState().auth;

    if (!signed && isPrivate) {
      history.push('/')
    }

    if(signed && !isPrivate) {
      history.push('/dashboard')
    }

    return (
      <Route
        { ...rest }
        component={ Component }  
      />
    )
};

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
}